import React, { Fragment, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import api from "../../api";
import toast from "react-hot-toast";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.post("users/verify-email/", {
        email: state?.email,
        code,
      });
      toast.success("Email verified successfully!");
      setTimeout(() => navigate("/login-register"), 2000);
    } catch (err) {
      const msg = err.response?.data?.error || "Verification failed.";
      toast.error(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <LayoutOne headerTop="visible">
        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="ms-auto me-auto col-lg-6">
                <div className="login-register-wrapper">
                  <h3 className="mb-4 text-center">Verify Email</h3>
                  <form onSubmit={handleVerify}>
                    <div className="billing-info">
                      <label className="mb-2">Verification Code</label>
                      <input
                        type="text"
                        placeholder="Enter verification code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        required
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    <div className="billing-back-btn mt-3">
                      <div className="billing-btn">
                        <button type="submit" className="btn" disabled={loading}>
                          {loading ? "Verifying..." : "Verify Email"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default VerifyEmail;
